// extracted by mini-css-extract-plugin
export default {"root":"AV56HG"};